import { getStore } from "store";
import * as _ from "lodash";
import {
    getNuorderProcessorAccounts,
    getLsProcessorAccounts,
    hasActivePaymentAccount,
} from "components/payments/helpers";

export default function (nextState, replace, callback) {
    const { scope } = getStore().getState();
    const nuOrderProcessorAccounts = getNuorderProcessorAccounts(_.get(scope.brand, "modules.payments.accounts", []));

    if (!nuOrderProcessorAccounts.length) {
        replace({ pathname: "/404" });
    }

    callback();
}

export function hasLsProcessor(nextState, replace, callback) {
    const { scope } = getStore().getState();
    const LSProcessorAccounts = getLsProcessorAccounts(_.get(scope.brand, "modules.payments.accounts", []));

    if (!LSProcessorAccounts.length) {
        replace({ pathname: "/404" });
    }

    callback();
}

export function hasActiveProcessor(nextState, replace, callback) {
    const { scope } = getStore().getState();
    const processorAccounts = hasActivePaymentAccount(scope);

    if (!processorAccounts) {
        replace({ pathname: "/404" });
    }
    callback();
}
